import { render, staticRenderFns } from "./booking_charges_search.vue?vue&type=template&id=3a5d9958&scoped=true"
import script from "./booking_charges_search.vue?vue&type=script&lang=js"
export * from "./booking_charges_search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d9958",
  null
  
)

export default component.exports